enum BaseActivityName {
	Monetary = 0,
	Physical = 1,
    Deliverable = 2,
	Curriculum = 3
}


export default BaseActivityName;